export const url = 'gabysi.com';
export const companyInitials = 'gsi';

// Routes - Prod

export const api = `https://api.${url}`;
export const admin = `https://admin.${url}`;
export const frontend = `https://${url}`;

// Token

export const tokenName = `${companyInitials}-admin-token`;
export const themeTokenName = `${companyInitials}-admin-theme-token`;
// Encryption
export const privateKeyTokeneName = `${companyInitials}-private-key`;
export const keyFingerprintTokenName = `${companyInitials}-key-fingerprint`;
export const keyPassphraseTokenName = `${companyInitials}-key-passphrase`;
